export enum ProviderShortNames {
	TINK = "tink",
	MPAY24 = "mpay24"
}
